import {
  createAction,
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';

import { RequestStatus } from 'shared/constants/State';
import { ComplaintSuggestion, ComplaintSuggestionResponse } from '../types';
import { getIdFromTitle } from './utils';

export const complaintSuggestionsAdapter = createEntityAdapter<
  ComplaintSuggestion
>({
  selectId: getIdFromTitle,
});

export const getInitialState = () =>
  complaintSuggestionsAdapter.getInitialState({
    status: RequestStatus.Ready,
    error: '',
  });

const name = 'medicalRecords/complaintsSuggestions';

const complaintsSuggestionsSlice = createSlice({
  name,
  initialState: getInitialState(),
  reducers: {
    setSuggestionsPending: (state) => ({
      ...state,
      status: RequestStatus.Pending,
      error: '',
    }),
    setSuggestionsSuccess: {
      prepare: (data: ComplaintSuggestionResponse[]) => ({
        payload: data.map(({ title, favorite }) => ({
          title,
          favorite,
          selected: false,
        })),
      }),
      reducer: (state, action: PayloadAction<ComplaintSuggestion[]>) => {
        const newState = complaintSuggestionsAdapter.setAll(
          state,
          action.payload,
        );
        newState.status = RequestStatus.Success;
      },
    },
    setSuggestionsError: (state, action: PayloadAction<string>) => ({
      ...state,
      status: RequestStatus.Error,
      error: action.payload,
    }),
    removeSuggestion: complaintSuggestionsAdapter.removeOne,
  },
});

export const {
  setSuggestionsPending,
  setSuggestionsSuccess,
  setSuggestionsError,
  removeSuggestion,
} = complaintsSuggestionsSlice.actions;

export const getSuggestions = createAction(`${name}/getSuggestions`);

export const addSuggestionToFavorites = createAction<
  ComplaintSuggestionResponse
>(`${name}/addSuggestionToFavorites`);

export default complaintsSuggestionsSlice.reducer;
